// extracted by mini-css-extract-plugin
module.exports = {"checkTip":"ReviewStatus_index_checkTip__1-XzL"};